import { createSelector } from 'reselect'
import { contextKey, initialContextState } from './state'

const root = state => state.guruRecommendations

export const selectRecommendationsFor = (contextType, contextId) => createSelector(
  root,
  s => s.byContext[contextKey(contextType, contextId)] || initialContextState(),
)

export const selectBadgeStateFor = (contextType, contextId) => createSelector(
  selectRecommendationsFor(contextType, contextId),
  s => s.badge,
)

export const selectIsRecommendationDismissed = signature => createSelector(
  root,
  s => Boolean(s.dismissals[signature]),
)
